import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5217df4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Nice work!", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Next section in", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#79dea3"} }, "12h 32m 18s", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Keep reading to unlock more quiz questions.", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { storeToRefs } from 'pinia';
import { computed, ref, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';

import {
  IonBackButton,
  IonButtons,
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  useIonRouter,
} from '@ionic/vue';

import { useData } from '@/composables/data';
import { useProgress } from '@/composables/progress';
import { useChapterStore } from '@/stores/chapter';
import { IChapter } from '@/support/models/chapter.interface';
import { IUnit } from '@/support/models/unit.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterFinishPage',
  setup(__props) {

const chapterStore = useChapterStore();
const { retryChapter } = chapterStore;
const { currentChapter } = storeToRefs(chapterStore);
const { countCorrectAnswers, countQuizzes } = useProgress();

const route = useRoute();
const ionRouter = useIonRouter();
const courseId = Number(route.params.course as string);
const unitId = Number(route.params.unit as string);
const chapterId = Number(route.params.chapter as string);

const dayStreak = 1; // TODO save date

const { getUnitData } = useData();
const chapters = ref<IChapter[]>([]);

onBeforeMount(async (): Promise<void> => {
  const unit: IUnit | undefined = await getUnitData(courseId, unitId);

  chapters.value = unit?.chapters ?? [];
});

const correctAnswers = computed(() => {
  return currentChapter.value ? countCorrectAnswers(currentChapter.value) : 0;
});

const quizCount = computed(() => {
  return currentChapter.value ? countQuizzes(currentChapter.value) : 0;
});

const onRetry = () => {
  if (currentChapter.value) {
    retryChapter(currentChapter.value);
  }

  ionRouter.navigate(
    `/course/${courseId}/unit/${unitId}/chapter/${chapterId}`,
    'forward',
    'replace'
  );
};

const backToUnit = () => {
  ionRouter.navigate(
    `/course/${courseId}/unit/${unitId}`,
    'forward',
    'replace'
  );
};

const currentChapterIndex = computed(
  (): number =>
    chapters.value.findIndex((chapter) => chapter.id === chapterId) ?? 0
);

const nextChapter = async () => {
  const nextChapterId = chapters.value[currentChapterIndex.value + 1]?.id;

  if (nextChapterId) {
    ionRouter.navigate(
      `/course/${courseId}/unit/${unitId}/chapter/${nextChapterId}`,
      'forward',
      'replace'
    );
  } else {
    backToUnit();
  }
};

const onContinue = () => {
  nextChapter();
};

if (!currentChapter.value) {
  backToUnit();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    "default-href": `/course/${_unref(courseId)}/unit/${_unref(unitId)}`
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Chapter finished")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        class: "ion-padding",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { class: "ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), { class: "ion-margin-vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), {
                    "size-md": "6",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRow), { class: "ion-justify-content-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { size: "9" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(_unref(correctAnswers)) + " Correct", 1),
                                  _createElementVNode("p", null, " You answered " + _toDisplayString(_unref(correctAnswers)) + " out of " + _toDisplayString(_unref(quizCount)) + " questions correctly! ", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), {
                    "size-md": "6",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRow), { class: "ion-justify-content-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { size: "9" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(dayStreak) + " Day Streak"),
                                  _hoisted_4
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        class: "secondary ion-margin-bottom",
                        expand: "full",
                        onClick: onRetry
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Retry Quiz ")
                        ]),
                        _: 1
                      }),
                      (chapters.value.length)
                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                            key: 0,
                            expand: "full",
                            onClick: onContinue
                          }, {
                            default: _withCtx(() => [
                              (_unref(currentChapterIndex) === chapters.value.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Finish "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_6, " Continue "))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})